import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// Pilota il motore di consenso iubenda (Cookie Solution con auto-blocking) dal nostro banner brandizzato.
const callIubenda = (fn, attempt = 0) => {
  const api = window._iub && window._iub.cs && window._iub.cs.api;
  if (api && typeof api[fn] === "function") {
    try { api[fn](); } catch (e) { console.debug("iubenda consent call failed:", e); }
  } else if (attempt < 25) {
    setTimeout(() => callIubenda(fn, attempt + 1), 150);
  }
};

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("2elab_cookie_consent")) setShow(true);
  }, []);

  const decide = (val) => {
    localStorage.setItem("2elab_cookie_consent", val);
    callIubenda(val === "all" ? "consent" : "reject");
    setShow(false);
  };

  const customize = () => callIubenda("openPreferences");

  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-[70] bg-ink text-greige">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:items-center gap-5">
        <p className="font-body text-sm text-greige/80 flex-1">
          Usiamo cookie tecnici e, previo consenso, strumenti di terze parti. Nessun dark pattern: scegli tu.
          Dettagli nella <Link to="/cookie-policy" className="underline">Cookie Policy</Link>.
        </p>
        <div className="flex flex-wrap gap-3 shrink-0">
          <button data-testid="cookie-customize" onClick={customize}
            className="font-mono2 text-xs uppercase tracking-widest text-greige/70 hover:text-greige px-3 py-2 transition-colors">
            Personalizza
          </button>
          <button data-testid="cookie-reject" onClick={() => decide("essential")}
            className="border border-greige/40 px-5 py-2 uppercase text-xs tracking-widest hover:bg-greige hover:text-ink transition-colors">
            Solo necessari
          </button>
          <button data-testid="cookie-accept" onClick={() => decide("all")}
            className="bg-greige text-ink px-5 py-2 uppercase text-xs tracking-widest hover:bg-white transition-colors">
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
};
